import { render, staticRenderFns } from "./uniformShop.vue?vue&type=template&id=10d4aea2&scoped=true&"
import script from "./uniformShop.vue?vue&type=script&lang=js&"
export * from "./uniformShop.vue?vue&type=script&lang=js&"
import style0 from "./uniformShop.vue?vue&type=style&index=0&id=10d4aea2&scoped=true&lang=less&"
import style1 from "./uniformShop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d4aea2",
  null
  
)

export default component.exports